import { render, staticRenderFns } from "./addLoginConfiguration.vue?vue&type=template&id=52525fe8&scoped=true&"
import script from "./addLoginConfiguration.vue?vue&type=script&lang=js&"
export * from "./addLoginConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./addLoginConfiguration.vue?vue&type=style&index=0&id=52525fe8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52525fe8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('52525fe8')) {
      api.createRecord('52525fe8', component.options)
    } else {
      api.reload('52525fe8', component.options)
    }
    module.hot.accept("./addLoginConfiguration.vue?vue&type=template&id=52525fe8&scoped=true&", function () {
      api.rerender('52525fe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/loginDisposition/components/addLoginConfiguration.vue"
export default component.exports